import React from "react";

const Android = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...props}
      fill="none"
    >
      <path
        d="M1.14478 0.341309C0.908093 0.576996 0.819336 0.959987 0.819336 1.35771V18.5776C0.819336 19.049 0.982057 19.4319 1.21874 19.6676L1.29271 19.7413L11.1595 10.0781V9.91609L1.14478 0.341309Z"
        fill="url(#paint0_linear_1_23587)"
      />
      <path
        d="M14.4433 13.2748L11.1001 10.1519V9.91623L14.3693 6.71973H14.4433L18.3486 8.97348C19.4581 9.59216 19.4581 10.6086 18.3486 11.2272L14.4433 13.2748Z"
        fill="url(#paint1_linear_1_23587)"
      />
      <path
        d="M14.4434 13.2748L11.1002 10.0046L1.2334 19.6678C1.58843 19.9919 2.10618 20.1392 2.83103 19.8298L14.4434 13.2748Z"
        fill="url(#paint2_linear_1_23587)"
      />
      <path
        d="M14.4436 6.71972L2.83126 0.253057C2.1212 -0.129934 1.55907 -0.0562821 1.15967 0.326709L11.1005 9.98987L14.4436 6.71972Z"
        fill="url(#paint3_linear_1_23587)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_23587"
          x1="3.65452"
          y1="-2.24766"
          x2="-4.80725"
          y2="6.38532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.007" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.512" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_23587"
          x1="19.7986"
          y1="2.1867"
          x2="0.541902"
          y2="2.1867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.409" stopColor="#FFBD00" />
          <stop offset="0.775" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_23587"
          x1="4.89652"
          y1="5.57529"
          x2="-8.91631"
          y2="19.6648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_23587"
          x1="-5.10948"
          y1="2.77717"
          x2="1.07755"
          y2="9.09904"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.069" stopColor="#2DA771" />
          <stop offset="0.476" stopColor="#15CF74" />
          <stop offset="0.801" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Android;
